import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header"; // Asegúrate de importar el componente Header
import Footer from "../components/Footer"; // Asegúrate de importar el componente Footer
import Loader from "../components/Loader"; // Asegúrate de importar el componente Loader

const Main = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Estado para controlar el loader

  useEffect(() => {
    const checkUserSession = () => {
      const storedUser = sessionStorage.getItem("user");

      if (storedUser) {
        setUser(JSON.parse(storedUser)); // Establece el usuario actual
      } else {
        navigate("/"); // Redirige al home si no hay usuario
      }

      setLoading(false); // Detiene el loader
    };

    checkUserSession();
  }, [navigate]);

  // Muestra el loader mientras se verifica la sesión
  if (loading) {
    return <Loader />;
  }

  // Si no hay usuario, no renderiza el contenido (ya se redirigió en el useEffect)
  if (!user) {
    return null;
  }

  return (
    <div>
      <Header user={user} />
      <main>
      <div className="content">
        <h1>Bienvenido, {user.name}</h1>
        <p>Este es tu dashboard principal.</p>
        <button
          onClick={() => {
            sessionStorage.removeItem("user"); // Limpia la sesión
            navigate("/"); // Redirige al home
          }}
        >
          Cerrar sesión
        </button>
      </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Main;